import React from 'react';
import { useNavigate } from 'react-router-dom';
import { resetUserSession } from './service/AuthService';
import './css/Daily.css';


const Support = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        resetUserSession();
        navigate('/login');
    };

    return (
        <div className="wrapper supportScreen">
            <div className="supportSurface">
                <div className="supportHeader">
                    <h2 className="dailyMainTitle">We're in this Together <br/>You're not Alone</h2>
                </div>

                <div className="supportSectionCard">
                    <h5 className="supportSectionTitle">Mental Wellness Support</h5>
                    <div className="homeBttnContainer supportActions">
                        {/* <button className="homeBttn" onClick={() => {window.open("https://whop.com/joined/trampoline-health/setback-support-GC7VvPxKch4rV3/app/", "_blank");}}>Community Support</button> */}
                        <button className="homeBttn" onClick={() => {window.open("https://cal.com/fernando-bohorquez-6tpybm/30min", "_blank");}}>Schedule One on One</button>
                        <button className="homeBttn" onClick={() => {navigate('/in-development')}}>Mental Health Hotlines</button>
                    </div>
                </div>

                <div className="supportSectionCard">
                    <h5 className="supportSectionTitle">Technical Support</h5>
                    <div className="homeBttnContainer supportActions">
                        <button className="homeBttn" onClick={() => {navigate('/settings')}}>Settings</button>
                        <button className="homeBttn" onClick={() => {window.open("https://forms.gle/DVWGTTjrHSwCga7F7", "_blank");}}>Bug Report Form</button>
                        <button className="homeBttn" onClick={() => {window.open("mailto:fernando@trampolinehealth.co?subject=App%20Support", "_blank");}}>Support Email</button>
                        <button className="homeBttn" onClick={handleLogout}>Log Out</button>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default Support;